import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Subject } from 'rxjs';
declare var $: any;

@Injectable({
  providedIn: 'root'
})
export class Global {
  DataMenu: any[];

  constructor(private translate: TranslateService) { }

  //online
  // _basedUrl="http://localhost:8080/sites/anp";
  // _baseUrlStatique = "https://sharetecma.sharepoint.com/sites/anp";
  // _baseUrlRacine =  "http://localhost:8080";
  // _baseUrlBrute="https://sharetecma.sharepoint.com";

//   //local
//   // _basedUrl = "https://www.anp.org.ma";
//    _basedUrl = "http://localhost:8080";
//   //_baseUrlStatique ="http://anp-dy.anp.ma:82";
//   _baseUrlStatique ="https://www.anp.org.ma";
//   // _baseUrlRacine = "https://www.anp.org.ma";
//    _baseUrlRacine = "http://localhost:8080";
//  // _baseUrlBrute = "http://anp-dy.anp.ma:82";
//   _baseUrlBrute = "https://www.anp.org.ma";
//  // _Url = "http://anp-dy.anp.ma:82";
//   _Url = "https://www.anp.org.ma";

  //server
  _baseUrlBrute="../"
  _baseUrlRacine =  "../";
  _basedUrl="../";
  _baseUrlStatique = "../";
  _Url = this._basedUrl;
   _GlobalBaseUrlStatique = this._baseUrlStatique;


  _FrUrl = "/Fra";
  _EnUrl = "/Eng";
  _ArUrl = "/Arb";


  // // local
  // _RouteFR = null;
  // _RouteEN = null;
  // _RouteAR = null;

  //server
  _RouteFR = "fr";
  _RouteEN = "en";
  _RouteAR = "ar";



  CurentLanguage = new BehaviorSubject<any>(
    window.location.pathname.split("/")[1] == this._RouteFR || window.location.pathname.split("/")[1] == this._RouteEN || window.location.pathname.split("/")[1] == this._RouteAR ?
      this.getCuentFromRoute(window.location.pathname.split("/")[1]) :
      (localStorage.getItem("lang") ?
        JSON.parse(localStorage.getItem("lang")) :
        { code: 'fr', url: this._basedUrl + this._FrUrl })
  );

  // CurentLanguage = new BehaviorSubject<any>(
  //   { code: 'fr', url: this._basedUrl + this._FrUrl }
  // );


  isloading = new BehaviorSubject<boolean>(false);
  navigationEnd = new Subject<boolean>();

  // setCurentLanguge(code) {
  //   switch (code) {
  //     case 'fr':
  //       this.CurentLanguage.next({
  //         code: 'fr',
  //         url: this._basedUrl + this._FrUrl
  //       })
  //       break;
  //     case 'en':
  //       this.CurentLanguage.next({
  //         code: 'en',
  //         url: this._basedUrl + this._EnUrl
  //       })
  //       break;
  //     case 'ar':
  //       this.CurentLanguage.next({
  //         code: 'ar',
  //         url: this._basedUrl + this._ArUrl
  //       })
  //       break;

  //     default:
  //       break;
  //   }
  //   localStorage.setItem('lang', JSON.stringify(this.CurentLanguage.value))
  //   this.translate.use(code);
  // }

  setCurentLanguge(code) {

    switch (code) {
      case 'fr':
        localStorage.setItem('lang', JSON.stringify({
          code: 'fr',
          url: this._basedUrl + this._FrUrl
        }))
        window.location.pathname = "/" + (this._RouteFR ? this._RouteFR + window.location.pathname.substring(3) : window.location.pathname);
        break;
      case 'en':
        localStorage.setItem('lang', JSON.stringify({
          code: 'en',
          url: this._basedUrl + this._EnUrl
        }))
        window.location.pathname = "/" + (this._RouteEN ? this._RouteEN + window.location.pathname.substring(3) : window.location.pathname);

        break;
      case 'ar':
        localStorage.setItem('lang', JSON.stringify({
          code: 'ar',
          url: this._basedUrl + this._ArUrl
        }))
        window.location.pathname = "/" + (this._RouteAR ? this._RouteAR + window.location.pathname.substring(3) : window.location.pathname);
        break;
      default:
        break;
    }
  }

  formattedDate(a) {
    if (a) {
      let d = new Date(a);
      //@ts-ignore
      d.addHours(1);
      let month = String(d.getMonth() + 1);
      let day = String(d.getDate());
      const year = String(d.getFullYear());

      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;
     
      return `${day}/${month}/${year}`;
    } else {
      return "";
    }

  }

  formattedDate2(a: string, format: string = "dd-MM-yyyy"): string {
    if (a) {
      const d = new Date(a);
      const addHours = (date: Date, hours: number) => {
        date.setTime(date.getTime() + hours * 60 * 60 * 1000);
        return date;
      };
      addHours(d, 1);

      let month = String(d.getMonth() + 1).padStart(2, '0');
      let day = String(d.getDate()).padStart(2, '0');
      const year = String(d.getFullYear());

      switch (format) {
        case "dd-MM-yyyy":
          return `${day}/${month}/${year}`;
        case "MM-dd-yyyy":
          return `${month}/${day}/${year}`;
        default:
          return `${day}/${month}/${year}`;
      }
    } else {
      return "";
    }
  }
  

  getCuentFromRoute(r) {
    switch (r) {
      case 'fr':
        return { code: 'fr', url: this._basedUrl + this._FrUrl , relativeUrl : '/fra'}
      case 'en':
        return { code: 'en', url: this._basedUrl + this._EnUrl , relativeUrl : '/eng'}
      case 'ar':
        return { code: 'ar', url: this._basedUrl + this._ArUrl , relativeUrl : '/arb'}
      default:
        break;
    }
  }

  isMobile() {
    var isMobile = false; //initiate as false
    // device detection
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
      || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
      isMobile = true;
    }
    return isMobile;
  }
  sidebar() {
    $("document").ready(()=>{
      if (this.isMobile()) {
        var selectedItem = '<a class="nav-link btn btn-info active" href="javascript:void(0)">'+ $("#sidebar .nav .nav-item a.active").html()+'</a>'
        $(".side-bar .selected-item").html(selectedItem);
        $(".side-bar .selected-item").addClass('dropIconSide');
        $('#sidebar').slideUp();
        $(".side-bar .selected-item").addClass('closed');
        $(".side-bar .selected-item").off("click").on('click', function (e) {
          $('#sidebar').slideToggle();
          $(".side-bar .selected-item").toggleClass('closed');
        });
      }
    });
  }

}
